import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
	changeRequest,
	resetPasswordPayload,
	updateIsChange,
} from "../../redux/reducers/ducks/autorizeDuck";
import "./changePassword.css";

import { getToasterNotifications } from "../../utils/getToasterNotification";
import { getToasterErrors } from "../../utils/getToasterErrors";
import Remarks from "../remarks/remarks";
import UploadImageToS3WithNativeSdk from "../uploadVedioS3/uploadVedioS3";

function ChangePasswordComponent({ isFromProfile }) {
	const [newPassword, setNewPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [passwordError, setPasswordError] = useState("");
	const [isSignupClicked, setIsSignupClicked] = useState(false);

	const navigate = useNavigate();

	const dispatch = useDispatch();
	const { change, isChange, resetPayload, loginResponseData } = useSelector(
		(state) => {
			return {
				change: state?.authorization?.changePass,
				isChange: state?.authorization?.isChange,
				resetPayload: state?.authorization?.resetPayload,
				loginResponseData: state.authorization?.loginResponseData,
			};
		}
	);
	const email = resetPayload?.email;
	// const token = resetPayload?.token;
	let token = localStorage.getItem(`token`);

	useEffect(() => {
		dispatch(resetPasswordPayload(resetPayload));
	}, []);
	// function made for handling the api
	const passwordPattern =
		/^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*()_+])[A-Za-z0-9!@#$%^&*()_+]{8,}$/;
	const handleSubmit = async (event) => {
		event.preventDefault();
		setIsSignupClicked(true);
		if (!passwordPattern.test(newPassword, confirmPassword)) {
			setPasswordError(
				" Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, and one special character."
			);
			return;
		}
		const requestData = {
			newPassword: newPassword,
			confirmPassword: confirmPassword,
			email: email,
			token: token,
		};
		dispatch(changeRequest(requestData));
	};

	useEffect(() => {
		if ((change?.status === 201 || change?.status === 200) && !isChange) {
			getToasterNotifications("Success - your password has been reset!");
			navigate("/loginUser");
			dispatch(updateIsChange(true));
			dispatch(resetPasswordPayload(null));
		} else if (
			change?.response?.status === 400 ||
			change?.response?.status === 401
		) {
			getToasterErrors(change?.response?.data?.message);
			navigate("/forgot-password");
			dispatch(updateIsChange(false));
		} else if (change?.response?.status === 406) {
			getToasterErrors(change?.response?.data?.message);
			dispatch(updateIsChange(false));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [change, isChange]);
	const handleConfirmPasswordChange = (event) => {
		const passwordValue = event.target.value;
		setConfirmPassword(passwordValue);
		setPasswordError("");
	};
	const handleNewPasswordChange = (event) => {
		const passwordValue = event.target.value;
		setNewPassword(passwordValue);
		setPasswordError("");
	};

	const [balloonId, setBalloonId] = useState("");
	// console.log(balloonId)
	return (
		<div className="container">
			<div className="d-flex border shadow-sm rounded-4 pr-2">
				<div className="background-color left-rounded-3">
					{!isFromProfile && (
						<h2 className="text-center mt-4 mb-4 fs-4">New Password</h2>
					)}
					{isFromProfile && (
						<div className="row d-flex justify-content-center">
							<img
								className="profile-img-rounded"
								src="/icons/prfile-img.png"
							/>
						</div>
					)}
					{isFromProfile && (
						<div className="text-center mx-auto">
							<h3 className="text-gray-800 mt-2 text-2xl">
								{loginResponseData?.data?.name}
							</h3>
						</div>
					)}
				</div>
				<div className="d-flex flex-column">
					<form className="mt-4 pt-4 w-60 h-96 profile-form-width">
						<h4 className="ml-13">My Profile</h4>
						<hr className="len" />
						<div className="d-flex ml-13">
							<div className={`form-group w-60 mb-3 shadow-sm`}>
								<span className="font-bold">Username</span>
								<br />
								<input
									disabled
									className="w-100 border rounded shadow-sm p-2"
									name="username"
									minLength="3"
									type="text"
									id="username"
									placeholder="Username"
									value={loginResponseData?.data?.username}
								/>
							</div>
							<div className={`form-group w-60 mb-3 ml-13 shadow-sm`}>
								<span className="font-bold">Email Address</span>
								<br />
								<input
									disabled
									className="w-100 border rounded shadow-sm p-2"
									name="email"
									minLength="3"
									type="text"
									id="email"
									placeholder="Email"
									value={loginResponseData?.data?.email}
								/>
							</div>
						</div>
						<h4 className="ml-13">Change Password</h4>
						<hr className="len" />
						<div className="d-flex ml-13">
							<div className="form-group w-60 mb-3 shadow-sm">
								<span className="font-bold">New Password</span>
								<br />
								<input
									className="w-100 border rounded shadow-sm p-2"
									name="newpassword"
									id="inputnewPassword"
									type="password"
									placeholder="New Password"
									onChange={handleNewPasswordChange}
								/>
								{isSignupClicked && passwordError && (
									<div className="error-message error-size">
										{passwordError}
									</div>
								)}
							</div>
							<div className="form-group w-60 mb-3 ml-13 shadow-sm">
								<span className="font-bold">Confirm Password</span>
								<br />
								<input
									required
									className="w-100 border rounded shadow-sm p-2"
									name="confirmPassword"
									id="inputconfirmPassword"
									type="password"
									placeholder="Confirm Password"
									onChange={handleConfirmPasswordChange}
								/>
								{isSignupClicked && passwordError && (
									<div className="error-message error-size">
										{passwordError}
									</div>
								)}
							</div>
						</div>
						<div className="text-center mb-5">
							{/*created the signup button*/}
							<Link to="">
								<Button
									type="submit"
									onClick={handleSubmit}
									className="change-passwor"
								>
									Update
								</Button>
							</Link>
						</div>

						<h4 className="ml-13">Show me your Emoji! Talent Competition</h4>
					</form>
					<div>
						<hr className="len" />
						<Remarks setBalloonId={setBalloonId} />
						<UploadImageToS3WithNativeSdk balloonId={balloonId} />
					</div>
				</div>
			</div>
		</div>
	);
}

export default ChangePasswordComponent;
